export class SearchUsers {
    static readonly type = '[User] SearchUsers';

    constructor(public payload: string) {}
}
